import {
  useState,
  createContext,
  useContext,
  useMemo,
  useEffect,
} from 'react';

export const BareContext = createContext(null);

export function BareProvider({ children }) {
  const [drafts, setDrafts] = useState([
    {
      id: 1,
      length: 0,
      tempo: 0,
      created: '',
      modified: '',
      name: 'aval',
      description: '',
      layers: [],
    },
    {
      id: 2,
      length: 0,
      tempo: 0,
      created: '',
      modified: '',
      name: 'dovom',
      description: '',
      layers: [],
    },
    {
      id: 3,
      length: 0,
      tempo: 0,
      created: '',
      modified: '',
      name: 'sevom',
      description: '',
      layers: [],
    },
    {
      id: 4,
      length: 0,
      tempo: 0,
      created: '',
      modified: '',
      name: 'chahrom',
      description: '',
      layers: [],
    },
    {
      id: 5,
      length: 0,
      tempo: 0,
      created: '',
      modified: '',
      name: 'panjom',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum',
      layers: [],
    },
    {
      id: 6,
      length: 0,
      tempo: 0,
      created: '',
      modified: '',
      name: 'shishom',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum',
      layers: [],
    },
    {
      id: 7,
      length: 0,
      tempo: 0,
      created: '',
      modified: '',
      name: 'ygygygyg',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum',
      layers: [],
    }
  ]);
  const [bares, setBares] = useState([
    {
      title: 'Benyamin / Jahanam / Bare 16',
      tempo: 120,
      layers: [
        {
          type: 1,
          file: {},
        },
        {
          type: 2,
          file: null,
        },
        {
          type: 3,
          file: null,
        },
        {
          type: 4,
          file: null,
        },
        {
          type: 5,
          file: {},
        }
      ]
    },
    {
      title: 'Benyamin / Raftan / Bare 2',
      tempo: 120,
      layers: [
        {
          type: 1,
          file: {},
        },
        {
          type: 2,
          file: null,
        },
        {
          type: 3,
          file: null,
        },
        {
          type: 4,
          file: null,
        },
        {
          type: 5,
          file: {},
        }
      ]
    },
    {
      title: 'Benyamin / Gisoo / 2 Bare 9',
      tempo: 120,
      layers: [
        {
          type: 1,
          file: {},
        },
        {
          type: 2,
          file: null,
        },
        {
          type: 3,
          file: null,
        },
        {
          type: 4,
          file: null,
        },
        {
          type: 5,
          file: {},
        }
      ]
    },
    {
      title: 'Benyamin / Malek / Bare 7',
      tempo: 120,
      layers: [
        {
          type: 1,
          file: {},
        },
        {
          type: 2,
          file: null,
        },
        {
          type: 3,
          file: null,
        },
        {
          type: 4,
          file: null,
        },
        {
          type: 5,
          file: {},
        }
      ]
    }
  ]);
  const [layers, setLayers] = useState(Array(5).fill(null));
  const [selectedDraft, setSelectedDraft] = useState(null);
  const [selectedBare, setSelectedBare] = useState(null);
  const [currentTime, setCurrentTime] = useState(0);
  const [totalTime, setTotalTime] = useState(0);
  const [startBare, setStartBare] = useState(0);
  const [mutes, setMutes] = useState(Array(5).fill(false));
  const [volume, setVolume] = useState(100);
  const [inProcess, setInProcess] = useState(true);
  const [baresUpdated, setBaresUpdated] = useState(false);

  // console.log(selectedBare)

  function generateArray() {
    const array = Array.from({ length: 99 }, () => ({
      length: Math.floor(Math.random() * 100),
      separator: Math.floor(Math.random() * 4) + 2,
      file: {},
    }));
    return array;
  }

  useEffect(() => {
    const bareList = generateArray();
    const totalLength = bareList.reduce((sum, obj) => sum + obj.length, 0);
    setTotalTime(totalLength);

    setLayers(Array(5).fill({
      bares: bareList,
      title: 'لایه جدید خوب',
      locked: false,
    }));

  }, [])


  const memoedValue = useMemo(() => {
    return {
      selectedDraft,
      setSelectedDraft,
      drafts,
      setDrafts,
      currentTime,
      setCurrentTime,
      totalTime,
      setTotalTime,
      startBare,
      setStartBare,
      layers,
      setLayers,
      mutes,
      setMutes,
      volume,
      setVolume,
      bares,
      setBares,
      inProcess,
      setInProcess,
      selectedBare,
      setSelectedBare,
      baresUpdated,
      setBaresUpdated,
    };
  }, [
    selectedDraft,
    setSelectedDraft,
    drafts,
    setDrafts,
    currentTime,
    setCurrentTime,
    totalTime,
    setTotalTime,
    startBare,
    setStartBare,
    layers,
    setLayers,
    mutes,
    setMutes,
    volume,
    setVolume,
    bares,
    setBares,
    inProcess,
    setInProcess,
    selectedBare,
    setSelectedBare,
    baresUpdated,
    setBaresUpdated,
  ]);

  return (
    <BareContext.Provider value={memoedValue}>
      {children}
    </BareContext.Provider>
  );
}

export default function useBareContext() {
  return useContext(BareContext);
}
